import { jwtDecode } from 'jwt-decode'

export const isTokenExpired = (token: string) => {
  const decoded = jwtDecode(token)
  return Math.floor(new Date().getTime() / 1000) >= (decoded.exp as number)
}
